var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page',[_c('template',{slot:"content"},[_c('help-content',{attrs:{"title":'歩数は激増しているまたは歩いても計測されない(Android)'}},[_c('template',{slot:"content"},[_c('div',{staticClass:"text"},[_vm._v("\n        スマホのハードウェアに異常が生じている可能性があります。スマホを再起動することで問題が解決されることがあります。繰り返し現象が発生する場合、ハードウエアが故障している可能性が高く、歩数計測にWeBandのご利用はおすすめです。\n      ")])])],2)],1)],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5e320d97","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Help8.vue
// module id = ikvi
// module chunks = 0